module.exports = __webpack_public_path__ + "static/media/newarrival-3.c54b841c.jpg";